import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import API from "../../../api/axios";
import { APP_URLS } from "../../../api/url";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Divider,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { approvalStatus, penaltyType } from "../../../config/constant";

const ApprovalPopup = ({ popup, _popup, _approved, isReject, requestId }) => {
  const [loading, setLoading] = useState(false);
  const [penalty, setPenalty] = useState(penaltyType.WITHOUT_PENALTY);
  const [rejectReason, setRejectReason] = useState("");
  const [isTouched, setIsTouched] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);

  useEffect(() => {
    if (!popup) {
      setIsTouched(false);
      setRejectReason("");
      setConfirmPopup(false);
      setPenalty(penaltyType.WITHOUT_PENALTY);
    }
  }, [popup]);

  const handleSubmit = async () => {
    if (
      isReject !== approvalStatus.ACCEPT &&
      (rejectReason === "" ||
        rejectReason === null ||
        rejectReason === undefined)
    ) {
      setIsTouched(true);
      return;
    }
    const payload = {
      status: isReject,
      ...(isReject === approvalStatus.ACCEPT ||
      isReject === approvalStatus.REJECTWITHPENALTY
        ? {
            penalty:
              isReject === approvalStatus.ACCEPT
                ? penalty
                : penaltyType.WITH_PENALTY,
          }
        : {}),
      ...(isReject === approvalStatus.REJECT ||
      isReject === approvalStatus.REJECTWITHPENALTY
        ? {
            reason: rejectReason,
          }
        : {}),
    };
    try {
      setLoading(true);
      const res = await API.post(
        `${APP_URLS.AUCTION_CANCEL_RESERVATION_ACTION}/${requestId}/action?_method=patch`,
        payload
      );
      if (res.status === 200) {
        _popup(false);
        setConfirmPopup(false);
        _approved((prev) => !prev);
        toast.success(
          isReject === approvalStatus.ACCEPT
            ? "Request accepted successfully."
            : "Request rejected successfully.",
          { position: toast.POSITION.TOP_RIGHT }
        );
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      const resp = error.response;
      const errorMessage =
        resp?.data?.data?.[Object.keys(resp.data.data)[0]]?.[0] ||
        resp?.data?.message ||
        "An error occurred";
      toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setLoading(false);
    }
  };

  const handleRejectReasonChange = (text) => {
    const trimmed = text.substring(0, 500);
    setRejectReason(trimmed);
  };

  const renderReasonField = () => (
    <FormControl fullWidth sx={{ mt: 1 }}>
      <TextField
        value={rejectReason}
        label="Reason"
        multiline
        minRows={1}
        maxRows={3}
        variant="outlined"
        onChange={(e) => handleRejectReasonChange(e.target.value)}
        onBlur={() => setIsTouched(true)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {`${rejectReason.length}/500`}
            </InputAdornment>
          ),
        }}
      />
      {isTouched && !rejectReason ? (
        <Typography color="red">Reason field is required</Typography>
      ) : null}
    </FormControl>
  );

  return (
    <>
      <Dialog
        open={popup && !confirmPopup}
        onClose={() => _popup(false)}
        sx={{
          ".MuiPaper-root": {
            width: "450px",
          },
        }}
      >
        <DialogTitle textAlign="center">
          <h5>
            {isReject === approvalStatus.ACCEPT && "Accept"}
            {isReject === approvalStatus.REJECT && "Reject"}
            {isReject === approvalStatus.REJECTWITHPENALTY &&
              "Reject with penalty"}
          </h5>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {isReject === approvalStatus.ACCEPT ? (
            <>
              <b>Apply penalty to buyer?</b>
              <FormControl fullWidth>
                <RadioGroup
                  value={penalty}
                  onChange={(e) => setPenalty(+e.target.value)}
                >
                  <FormControlLabel
                    value={penaltyType.WITH_PENALTY}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={penaltyType.WITHOUT_PENALTY}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </>
          ) : (
            renderReasonField()
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => _popup(false)}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" disabled={loading}>
            {loading
              ? isReject === approvalStatus.ACCEPT
                ? "Accepting..."
                : "Rejecting..."
              : isReject === approvalStatus.ACCEPT
              ? "Accept"
              : "Reject"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ApprovalPopup;
